const reFifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
const reEighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/i

export const idCardBirthDay = function (value) {
  const len = value.length

  if (len === 15) {
    const birthday = value.match(reFifteen)
    return [birthday[2], birthday[3], birthday[4]].join('-')
  } else {
    const birthday = value.match(reEighteen)
    return [birthday[2], birthday[3], birthday[4]].join('-')
  }
}

export const idCardSex = function (value) {
  const len = value.length

  if (len === 15) {
    return value[14] % 2 === 0 ? 0 : 1
  } else {
    return value[16] % 2 === 0 ? 0 : 1
  }
}

const regMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
export const isMobile = function () {
  return regMobile.test(window.navigator.userAgent)
}

export const desensitize = (str, maskChar = '*', start = 0, end = str.length - 1, enable = true) => {
  if (!enable) return str
  const maskedStr = str.split('')
  for (let i = start; i <= end; i++) {
    maskedStr[i] = maskChar
  }
  return maskedStr.join('')
}

/**
 * 转换url，匹配格式转化成目标格式
 * @param obj
 * @param origin
 */
export const replaceLinks = (obj, origin = window.location.origin) => {
  // 正则表达式将匹配所有小程序匹配的格式
  const regexPattern = new RegExp(
    'https?://' + // 匹配协议 'http://' 或 'https://'
    '[^/]+' + // 转义域名中的点并匹配域名
    '(?:/h5/[^/]+)?' + // 非捕获组，可选地匹配 '/h5/{airline}'
    '/modules/content/pages/([^/]+)/([^/?]+)\\?id=([^/]+)' + // 匹配 '/{type}/{page}?id={id}'
    '|' + // OR
    'https?://' + // 匹配协议 'http://' 或 'https://'
    '[^/]+' + // 转义域名中的点并匹配域名
    '(?:/h5/[^/]+)?' + // 非捕获组，可选地匹配 '/h5/{airline}'
    '(?:/m)?' + // 非捕获组，可选地匹配 '/m'
    '/micro/main/([^/?]+)/([^/]+)', // 匹配 '/micro/main/{type}/{id}'
    'i' // 标志表明匹配应该是不区分大小写的
  )

  // 迭代对象的每个属性
  traverseObject(obj, (path, value) => {
    if (typeof value === 'string') {
      return value.replace(regexPattern, (match, p1, p2, p3, p4, p5) => {
        // 检查当前匹配的URL是否与当前页面同源
        console.log('match >>>> ', match)
        if (isSameRootOrigin(match, origin)) {
          const type = p1 || p4 // 获取{type}值
          const id = p3 || p5 // 获取{id}值
          return `/micro/main/${type}/${id}`
        } else {
          return match // 不同源的URL不进行替换
        }
      })
    } else {
      return value
    }
  })
  return obj
}

export const getCmsDataFormat = async () => {
  try {
    const cmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) || {}
    const cmsFormatPageData = replaceLinks(cmsData)
    return cmsFormatPageData
  } catch (err) {
    console.log('err >>>> ', err)
  }
}

// 判定是否同源
function isSameRootOrigin (currentDomain, domainToCheck) {
  try {
    const currentRootDomain = new URL(currentDomain)?.hostname.split('.').slice(-2).join('.')
    const domainToCheckRoot = new URL(domainToCheck)?.hostname.split('.').slice(-2).join('.')
    return currentRootDomain === domainToCheckRoot
  } catch (error) {
    console.log('error >>>> ', error)
  }
}

function traverseObject (obj, callback) {
  // 用于递归遍历的辅助函数，它还传递了path参数来追踪当前属性的路径
  function traverse (currentObj, callback, path = '') {
    for (const key in currentObj) {
      if (Object.prototype.hasOwnProperty.call(currentObj, key)) {
        // 生成当前属性的路径
        const currentPath = path ? `${path}.${key}` : key
        // 获取当前属性的值
        const value = currentObj[key]

        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
          // 如果是对象，则递归遍历
          traverse(value, callback, currentPath)
        } else {
          // 如果是基本类型或者数组，则执行回调，可能会对值进行修改
          currentObj[key] = callback(currentPath, value)
        }
      }
    }
  }
  traverse(obj, callback)
}
